/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DialogScheduleSettings = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The DialogScheduleSettings model module.
   * @module model/DialogScheduleSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DialogScheduleSettings</code>.
   * @alias module:model/DialogScheduleSettings
   * @class
   */
  var exports = function() {
    var _this = this;














  };

  /**
   * Constructs a <code>DialogScheduleSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DialogScheduleSettings} obj Optional instance to populate.
   * @return {module:model/DialogScheduleSettings} The populated <code>DialogScheduleSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ScheduleRhytmID')) {
        obj['ScheduleRhytmID'] = ApiClient.convertToType(data['ScheduleRhytmID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('IsActive')) {
        obj['IsActive'] = ApiClient.convertToType(data['IsActive'], 'Boolean');
      }
      if (data.hasOwnProperty('StartDate')) {
        obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'Date');
      }
      if (data.hasOwnProperty('PeriodDaysOpen')) {
        obj['PeriodDaysOpen'] = ApiClient.convertToType(data['PeriodDaysOpen'], 'Integer');
      }
      if (data.hasOwnProperty('UseScheduling')) {
        obj['UseScheduling'] = ApiClient.convertToType(data['UseScheduling'], 'Boolean');
      }
      if (data.hasOwnProperty('MicrosoftTeamsBotConversationID')) {
        obj['MicrosoftTeamsBotConversationID'] = ApiClient.convertToType(data['MicrosoftTeamsBotConversationID'], 'Integer');
      }
      if (data.hasOwnProperty('DistributionChannelID')) {
        obj['DistributionChannelID'] = ApiClient.convertToType(data['DistributionChannelID'], 'Integer');
      }
      if (data.hasOwnProperty('IsFeedbackDialog')) {
        obj['IsFeedbackDialog'] = ApiClient.convertToType(data['IsFeedbackDialog'], 'Boolean');
      }
      if (data.hasOwnProperty('StrategyDescriptionID')) {
        obj['StrategyDescriptionID'] = ApiClient.convertToType(data['StrategyDescriptionID'], 'Integer');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} ScheduleRhytmID
   * @default 0
   */
  exports.prototype['ScheduleRhytmID'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Boolean} IsActive
   * @default false
   */
  exports.prototype['IsActive'] = false;
  /**
   * @member {Date} StartDate
   */
  exports.prototype['StartDate'] = undefined;
  /**
   * @member {Integer} PeriodDaysOpen
   * @default 0
   */
  exports.prototype['PeriodDaysOpen'] = 0;
  /**
   * @member {Boolean} UseScheduling
   * @default false
   */
  exports.prototype['UseScheduling'] = false;
  /**
   * @member {Integer} MicrosoftTeamsBotConversationID
   */
  exports.prototype['MicrosoftTeamsBotConversationID'] = undefined;
  /**
   * @member {Integer} DistributionChannelID
   * @default 0
   */
  exports.prototype['DistributionChannelID'] = 0;
  /**
   * @member {Boolean} IsFeedbackDialog
   * @default false
   */
  exports.prototype['IsFeedbackDialog'] = false;
  /**
   * @member {Integer} StrategyDescriptionID
   */
  exports.prototype['StrategyDescriptionID'] = undefined;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


